import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface NoResultCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle():object;
    getImageDivCSSStyle():object;
    getMobileImageDivCSSStyle():object;
    getNoResultLabelCSSStyle():object;
    getMobileNoResultLabelCSSStyle():object;

    getNoResultContentCSSStyle():object;
    getMobileNoResultContentCSSStyle():object;

}

export class NoResultCSSStyleImpl extends UIComponentCSSStyleImpl implements NoResultCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            justifyContent:'center',
            display:'flex',
            flexFlow:'row',
            textAlign: "center",
            alignItems:'center'

        };
    }

    getInnerWrapperCSSStyle():object
    {
        return{
            width:'96%',
            height:'100%',
            justifyContent:'center'
        };
    }

    getImageDivCSSStyle():object
    {
        return{
                width:'100%',
                marginTop:'50px',
                height:'177px',
                opacity:'60%',
                justifyContent:'center'

        };
    }
    getMobileImageDivCSSStyle():object
    {
        return{
                width:'100%',
                marginTop:'50px',
                height:'87px',
                opacity:'60%',
                justifyContent:'center'

        };
    }

    getNoResultLabelCSSStyle():object
    {
        return{
            width:'100%',
            height:'41px',
            marginTop:'10px',
            lineHeight:'41px',
            fontSize:'30px',
            align:'center',
            fontWeight:'500',
            color:'#B3B3B3'
        };
    }
    getMobileNoResultLabelCSSStyle():object
    {
        return{
            width:'100%',
            height:'41px',
            marginTop:'10px',
            lineHeight:'41px',
            fontSize:'20px',
            align:'center',
            fontWeight:'500',
            color:'#B3B3B3'
        };
    }

    getNoResultContentCSSStyle():object
    {
        return{
            height:'38px',
            width:'260px',
            color:'#B3B3B3',
            fontSize:'14px',
            lineHeight:'18px',
            fontWeight:'300'
        };
    }

    getMobileNoResultContentCSSStyle():object
    {
        return{
            height:'38px',
            width:'260px',
            color:'#B3B3B3',
            fontSize:'10px',
            lineHeight:'18px',
            fontWeight:'300'
        };
    }

    getInputDivCSSStyle():object
    {
        return{
            marginTop:'25px',width:'100%',height:'42px',
            boxShadow: '2px 2px 4px 0 rgba(0,0,0,0.1)'
        };
    }

    
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/noresult/noresultcss.tsx